import { render, staticRenderFns } from "./EditMoveDialog.vue?vue&type=template&id=425a5b6c&"
import script from "./EditMoveDialog.vue?vue&type=script&lang=js&"
export * from "./EditMoveDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports